import * as React from 'react';
import { useRadioGroup } from '@mui/material';
import {
  Radio,
  type RadioProps,
  TextField,
  type TextFieldProps,
} from '../../../../../components';

export type RadioWithTextFieldProps = RadioProps & {
  textFieldProps: TextFieldProps;
};

export const RadioWithTextField: React.FunctionComponent<
  RadioWithTextFieldProps
> = props => {
  const radioGroup = useRadioGroup();
  const { textFieldProps, ...radioProps } = props;

  return (
    <div>
      <Radio {...radioProps} />
      {radioGroup?.value === radioProps.value && (
        <TextField {...textFieldProps} />
      )}
    </div>
  );
};
